import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListCheck, faDownload } from '@fortawesome/free-solid-svg-icons';

const TablePagination = ({
  currentPage,
  totalPages,
  paginate,
  itemsPerPage,
  setItemsPerPage,
  setCurrentPage,
  openColumnModal,
  downloadExcel,
  data,
  totalRecords, // Add this prop
  recordsOnCurrentPage // Add this prop
}) => {
  // Generate page numbers with improved display logic
  const getPageNumbers = () => {
    const pageNumbers = [];
    const lastPage = totalPages;

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push({ value: i, type: 'number' });
      }
    } else {
      pageNumbers.push({ value: 1, type: 'number' });

      if (currentPage > 4) {
        pageNumbers.push({ value: '...', type: 'ellipsis' });
      }

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      for (let i = start; i <= end; i++) {
        pageNumbers.push({ value: i, type: 'number' });
      }

      if (currentPage < totalPages - 3) {
        pageNumbers.push({ value: '...', type: 'ellipsis' });
      }

      pageNumbers.push({ value: totalPages, type: 'number' });
    }

    return pageNumbers;
  };

  return (
    <div className="pagination">
      {totalPages > 1 && (
        <div className="pagination-buttons">
          {/* Previous page button */}
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            &laquo;
          </button>

          {/* Page numbers with ellipsis */}
          {getPageNumbers().map((item, index) => (
            item.type === 'ellipsis' ? (
              <span key={`ellipsis-${index}`} className="pagination-ellipsis">
                {item.value}
              </span>
            ) : (
              <button
                key={`page-${item.value}`}
                onClick={() => paginate(item.value)}
                className={`pagination-btn ${currentPage === item.value ? 'active' : ''}`}
              >
                {item.value}
              </button>
            )
          ))}

          {/* Next page button */}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            &raquo;
          </button>
        </div>
      )}

      {/* Items per page selector */}
      <select
        className="items-per-page1"
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
      >
        <option value={10}>10 per page</option>
        <option value={20}>20 per page</option>
        <option value={25}>25 per page</option>
      </select>

      <div className="list-columns-btn">
        <button
          className="list"
          onClick={openColumnModal}
        >
          <FontAwesomeIcon icon={faListCheck} />
        </button>
        <button onClick={() => downloadExcel(data)} className='download-btn'>
          <FontAwesomeIcon icon={faDownload} />
        </button>
      </div>
    </div>
  );
};

export default TablePagination;